// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/latitude-longitude.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/latitude-longitude/latitude-longitude.js';

mount([g0]);
